import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ClearButton from "../../app/common/ClearButton";

export default function MultiDateInput({ selectedDates, setSelectedDates, placeholder }) {
  const [pickerOpen, setPickerOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleDateChange = (date) => {
    const exists = selectedDates.some(
      (d) => d.toDateString() === date.toDateString()
    );

    if (exists) {
      setSelectedDates(
        selectedDates.filter((d) => d.toDateString() !== date.toDateString())
      );
    } else {
      setSelectedDates([...selectedDates, date]);
    }
  };

  const removeDate = (dateToRemove) => {
    setSelectedDates(
      selectedDates.filter(
        (d) => d.toDateString() !== dateToRemove.toDateString()
      )
    );
  };

  // 📌 Handle outside click to close the date picker
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setPickerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="multi-date-wrapper"
      ref={wrapperRef}
    >
      <div
        className="multi-date-input"
        onClick={() => setPickerOpen(!pickerOpen)}
      >
        {selectedDates.length === 0 && (
          <span className="date-placeholder">{placeholder || "Select Dates"}</span>
        )}
        {selectedDates.map((date, i) => (
          <div
            key={i}
            className="multi-date-chip"
          >
            {date.toLocaleDateString()}
            <span
              onClick={(e) => {
                e.stopPropagation();
                removeDate(date);
              }}
              className="remove-date"
            >
              ×
            </span>
          </div>
        ))}
      </div>

      {
        selectedDates.length > 0 && (
          <ClearButton onClick={() => setSelectedDates([])} />
        )}


      {pickerOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            top: "105%",
            left: 0,
          }}
        >
          <DatePicker
            inline
            selected={null}
            onChange={handleDateChange}
            highlightDates={selectedDates}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
          />
        </div>
      )}
    </div>
  );
}
